import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccessControlEntry } from '../shared/auth/access-control-entry';
import { AuthGuard } from '../shared/auth/auth-guard.service';
import { SecurityElementNames } from '../shared/auth/constants/security-element-names.service';
import { CreditCardActivityComponent } from './credit-card-activity/credit-card-activity.component';
import { GatewayResolutionPageComponent } from './gateway-resolution-page/gateway-resolution-page.component';
import { EcomTransactionsComponent } from './ecommerce/ecommerce-transactions/ecommerce-transactions.component';
import { PostedBatchesComponent } from './posted-batches/posted-batches.component';
import { PostTransactionsComponent } from './post-transactions/post-transactions.component';
import { JournalEntryDetailsComponent } from './journal-entry-details/journal-entry-details.component';
import { ArbcreationComponent } from './arbcreation/arbcreation.component';
import { PledgeCampaignsComponent } from './pledge-campaigns/pledge-campaigns.component';
import { PledgeCampaignEditComponent } from './pledge-campaigns/pledge-campaign-edit/pledge-campaign-edit.component';
import { PledgeEditComponent } from './pledge/pledge-edit/pledge-edit.component';

const securityElementNames = new SecurityElementNames();
const routes: Routes = [
  {
    title: 'revenue.credit-card-activity.credit-card-activity',
    path: 'credit-card-activity',
    component: CreditCardActivityComponent,
    canActivate: [AuthGuard],
    data: {
      accessControls: [
        {
          SecurityElement: securityElementNames.Credit_Card_Processing,
          MinimumAccessLevel: 1,
        } as AccessControlEntry,
      ],
    },
  },
  {
    title: 'revenue.gateway-resolution-tree.page-title',
    path: 'gateway-resolution',
    component: GatewayResolutionPageComponent,
    canActivate: [AuthGuard],
    data: {
      accessControls: [
        {
          SecurityElement: securityElementNames.Credit_Card_Processing,
          MinimumAccessLevel: 1,
        } as AccessControlEntry,
      ],
    },
  },
  {
    title: 'shared.container.top-nav.component.menu.revenue.ecommerce-transactions',
    path: 'ecommerce',
    component: EcomTransactionsComponent,
    canActivate: [AuthGuard],
  },
  {
    title: 'shared.container.top-nav.component.menu.revenue.posted-batches',
    path: 'posted-batches',
    component: PostedBatchesComponent,
    canActivate: [AuthGuard],
  },
  {
    title: 'shared.container.top-nav.component.menu.revenue.post-transactions',
    path: 'post-transactions',
    component: PostTransactionsComponent,
    canActivate: [AuthGuard],
  },
  {
    title: 'shared.container.top-nav.component.menu.revenue.arb-creation-activity',
    path: 'arbcreation',
    component: ArbcreationComponent,
    canActivate: [AuthGuard],
  },
  {
    title: 'shared.container.top-nav.component.menu.revenue.pledge-campaigns',
    path: 'pledge-campaigns',
    component: PledgeCampaignsComponent,
    canActivate: [AuthGuard],
  },
  {
    title: 'shared.container.top-nav.component.menu.revenue.pledge-campaign',
    path: 'pledge-campaigns/:pledgeCampaignId',
    component: PledgeCampaignEditComponent,
    canActivate: [AuthGuard],
  },
  {
    title: 'revenue.pledge.title',
    path: 'pledge/:pledgeId',
    component: PledgeEditComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'test',
    component: JournalEntryDetailsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RevenueRoutingModule {}
